import { Helper } from '../../../../classes/helper'
import { cover } from '../../../../utility/constant/helper.constant'
import { useMontage } from '../../../../context/montage.context'

export const FrontBar = (): JSX.Element => {
  const { measure, roof } = useMontage()

  return (
    <>
      {[...Array(2)].map((_, index) => {
        return (
          <group
            key={index}
            position={[
              0,
              Helper.convertToMeter(measure.frontHeight!),
              Helper.convertToMeter(measure.userDepth!),
            ]}
            castShadow={cover.terraceCover.castShadow}
          >
            <mesh
              position={[
                0,
                0,
                index === 1 ? Helper.convertToMeter(cover.bar.depth) : 0,
              ]}
              castShadow={cover.terraceCover.castShadow}
              receiveShadow={false}
            >
              <boxGeometry
                args={[
                  Helper.convertToMeter(measure.userWidth!),
                  Helper.convertToMeter(cover.bar.height + 1), //? +1 looks better
                  Helper.convertToMeter(cover.bar.depth),
                ]}
              />
              <meshPhysicalMaterial color={roof.userColor} />
            </mesh>
          </group>
        )
      })}

      {/* Rinnenform */}
      {/* {roof.ditchForm !== 'classic' && <FrontBarModel />} */}
    </>
  )
}
